import { timelineNodes } from "@/mocks/gossip";

const kindMeta = {
  start: { icon: "ri-arrow-up-line", cls: "bg-background-200 text-foreground-700", label: "开端" },
  flow: { icon: "ri-share-forward-line", cls: "bg-background-200 text-foreground-700", label: "发酵" },
  deny: { icon: "ri-close-circle-line", cls: "bg-secondary-500 text-background-50", label: "辟谣" },
  reverse: { icon: "ri-refresh-line", cls: "bg-accent-500 text-foreground-950", label: "反转" },
  fresh: { icon: "ri-flashlight-fill", cls: "bg-primary-500 text-background-50", label: "新进展" },
} as const;

export default function TimelineSection() {
  return (
    <section id="reverse" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto mb-10 max-w-2xl text-center">
          <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-semibold text-accent-800">
            <i className="ri-history-line"></i>
            全景复盘
          </div>
          <h2 className="font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
            一起“停播退圈”传闻的完整反转过程
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            从一张截图流出，到多方跟进，再到本人生动辟谣、新瓜浮现。拆解谣言是如何一步步被“传实”又被“打回”的。
          </p>
        </div>

        <div className="relative mx-auto max-w-3xl">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 md:left-1/2"></div>
          <div className="flex flex-col gap-8">
            {timelineNodes.map((node, i) => {
              const meta = kindMeta[node.kind];
              return (
                <div key={i} className="relative flex md:items-center">
                  <div
                    className={`absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-full border-4 border-background-100 ${meta.cls} md:left-1/2 md:-translate-x-1/2`}
                  >
                    <i className={meta.icon}></i>
                  </div>

                  <div className="ml-14 w-full md:ml-0 md:w-[calc(50%-2.5rem)] md:mr-auto">
                    <div
                      className={`rounded-xl border border-background-200 bg-background-50 p-5 ${
                        i % 2 === 1 ? "md:order-2" : ""
                      }`}
                    >
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="text-xs font-semibold text-foreground-500">{node.time}</span>
                        <span
                          className={`inline-flex items-center rounded px-2 py-0.5 text-xs font-bold ${meta.cls}`}
                        >
                          <i className={`${meta.icon} mr-1`}></i>
                          {meta.label}
                        </span>
                      </div>
                      <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">{node.title}</h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{node.desc}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-3xl rounded-xl border border-primary-200 bg-primary-100/60 p-5 text-center">
          <p className="flex flex-wrap items-center justify-center gap-2 text-sm text-foreground-800">
            <i className="ri-lightbulb-flash-line text-primary-600"></i>
            这条反转链条告诉我们：脱离信源的传播，离“假瓜”只有一步之遥。
          </p>
        </div>
      </div>
    </section>
  );
}